import { Observable } from 'rxjs';

export interface ApiResponse {
  code: number,
  message: any
}

export abstract class RealignmentData {
  abstract save(params: any): Observable<ApiResponse>;
  abstract get(year: string, code: string, campus: any, page: any, page_size: any): Observable<ApiResponse>;
  abstract delete(id: any): Observable<ApiResponse>;
  abstract update(params: any): Observable<ApiResponse>;
  abstract changeStatus(params: any): Observable<ApiResponse>;
  abstract nextSeries(params: any): Observable<ApiResponse>;
  abstract deleteDetails(id: any): Observable<ApiResponse>;
}
